export default {
    _bumpy_roadregular: 'bumpy_roadregular',
    _curse_casualregular: 'curse_casualregular',
    _sanchez_regular: 'sanchez_regular',
}